import {Injectable} from '@angular/core';
import {CompanyResponse} from '@frontend/shared-api';
import {OfficeViewModel} from '../project-wizard-office-step/office.models';

@Injectable({
  providedIn: 'root',
})
export class ProjectWizardOfficeDataService {
  flattenCompanyData = (companies: CompanyResponse[]): OfficeViewModel[] => {
    const result: OfficeViewModel[] = [];

    for (const company of companies) {
      const companyOffices = this.extractOfficesFromCompany(company);
      result.push(...companyOffices);
    }

    return result;
  };

  private extractOfficesFromCompany(company: CompanyResponse): OfficeViewModel[] {
    const offices: OfficeViewModel[] = [];

    for (const country of company.countries) {
      const countryOffices = this.extractOfficesFromCountry(country, company.id);
      offices.push(...countryOffices);
    }

    return offices;
  }

  private extractOfficesFromCountry(
    country: CompanyResponse['countries'][0],
    companyId: number,
  ): OfficeViewModel[] {
    const offices: OfficeViewModel[] = [];

    for (const city of country.cities) {
      const cityOffices = city.offices.map((office) => ({
        id: office.id,
        name: office.name,
        cityId: city.id,
        cityName: city.name,
        countryId: country.id,
        countryName: country.countryCode,
        companyId: companyId,
        selectedFunctions: [],
      }));
      offices.push(...cityOffices);
    }

    return offices;
  }

  extractCountriesFromOffices(offices: OfficeViewModel[]): {id: number; code: string}[] {
    const countriesMap = new Map<number, {id: number; code: string}>();

    offices.forEach((office) => {
      if (!countriesMap.has(office.countryId)) {
        const code = office.countryName;
        countriesMap.set(office.countryId, {id: office.countryId, code});
      }
    });

    return Array.from(countriesMap.values());
  }
}
